/**
 * Barentsgallery – Minimal theme JavaScript
 * Only essential interactivity; no frameworks needed.
 */

(function () {
  'use strict';

  /* ---- Mobile navigation toggle ---- */
  function setupNavToggle() {
    var btn = document.querySelector('.nav-toggle');
    var nav = document.getElementById('main-nav');
    if (!btn || !nav) return;

    function closeNav(returnFocus) {
      btn.setAttribute('aria-expanded', 'false');
      nav.classList.remove('open');
      if (returnFocus) btn.focus();
    }

    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        closeNav();
      } else {
        btn.setAttribute('aria-expanded', 'true');
        nav.classList.add('open');
      }
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeNav);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        closeNav(true);
      }
    });

    window.matchMedia('(max-width: 48rem)').addEventListener('change', function (e) {
      if (!e.matches) closeNav();
    });
  }

  /* ---- Sticky header scroll effect ---- */
  function setupStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        if (window.scrollY > 50) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
        }
      });
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Init ---- */
  document.addEventListener('DOMContentLoaded', function () {
    setupNavToggle();
    setupStickyHeader();
  });
})();
